import React from "react";
import { Link } from "react-router-dom";
import Binding from "../../binding";
import Context from "../../Context";
import { getKeysByCriteria } from "../Layout/Workdoc/typedoc";
import Blocker from "../Misc/Blocker";
import DocumentPicker from "./DocumentPicker";

export default class ObjectLink extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }

  load = async () => {
    if (this.props.id) {
      this.setState({ pending: true });
      let items = await this.context.api.qa("/object/link/list", {
        filter: { objectid: this.props.id },
      });
      this.setState({
        items,
        pending: false,
      });
    }
  };

  deleteClick = (item = {}) => {
    this.context
      .ask(
        `Убрать связанный документ ${item.linkedlabel}`,
        "Убрать документ",
        "question"
      )
      .then((answer) => {
        if (answer.value) {
          this.delete(item);
        }
      });
  };

  delete = async (item = {}) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/object/unlink", {
      object: this.props.id,
      linked: item.linkedid,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  add = async (id, document) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/object/link", {
      object: this.props.id,
      linked: id,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    const { pending, items = [] } = this.state;
    const { canManage, title } = this.props;
    return (
      <>
        <Blocker on={pending} hAuto>
          {title && items.length > 0 ? <h5>{title}</h5> : null}
          {items.map((i, idx) => {
            let linked = i.linked || {};
            let binding = new Binding(linked);
            const typeDocument = binding.typedoc || {};
            let label = (
              <>
                <span
                  className={`svg-icon mr-2 opacity-50 svg-icon-${typeDocument.iconColor}`}
                >
                  {typeDocument.icon}
                </span>{" "}
                {binding.label}
              </>
            );

            return (
              <div className="my-4 d-flex" key={idx}>
                {binding.url ? (
                  <Link to={binding.url}>{label}</Link>
                ) : (
                  <div>{label}</div>
                )}
                {canManage && (
                  <div className="ml-2">
                    <span
                      onClick={() => this.deleteClick(i)}
                      title="Убрать"
                      className="text-muted text-hover-danger ml-2 cursor-pointer"
                    >
                      <i className="fa fa-times"></i>
                    </span>
                  </div>
                )}
              </div>
            );
          })}
          {canManage && (
            <div className="mt-5 pt-4 border-top">
              <DocumentPicker
                states={["disabled"]}
                onChange={this.add}
                classes={this.props.classes || getKeysByCriteria("inWorkdoc")}
                input={
                  <div className="btn btn-light">
                    <i className="flaticon2-add-1 mr-2"></i>Добавить документ
                  </div>
                }
              />
            </div>
          )}
        </Blocker>
      </>
    );
  }
}
